import React from 'react'
import styled from '@emotion/styled'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {PriceWrapper} from '../PriceComposition'
import {OfferLayoutBaseProps, OfferLayoutLoadingProps} from '.'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const LoadingWrapper = styled(Wrapper)`
  align-items: flex-start;
  gap: ${cssTheme.layout.spacing.s600};
  padding: ${cssTheme.layout.spacing.s400};
`

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: ${cssTheme.layout.spacing.s200};
  ${PriceWrapper} {
    &--column {
      align-items: flex-end;
    }
  }
`

type Props = Pick<
  OfferLayoutBaseProps,
  | 'isLoading'
  | 'priceComponent'
  | 'ctaComponent'
  | 'providerLogoComponent'
  | 'dataId'
  | 'cashbackComponent'
>

export const CompactWithoutRoomNameLayout: React.FC<
  Props | OfferLayoutLoadingProps
> = ({
  isLoading,
  priceComponent,
  providerLogoComponent,
  ctaComponent,
  dataId,
  cashbackComponent
}) => {
  if (isLoading)
    return (
      <LoadingWrapper data-id="loader">
        <div>
          <SkeletonLoader width={56} align="right" />
          <SkeletonLoader width={90} align="right" />
        </div>
        <SkeletonLoader width={127} marginTop={0} />
      </LoadingWrapper>
    )

  return (
    <Wrapper data-id={dataId}>
      <LeftWrapper>
        {priceComponent}
        {providerLogoComponent}
        {cashbackComponent}
      </LeftWrapper>
      <div>{ctaComponent}</div>
    </Wrapper>
  )
}
